// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2q1s6","insightsList":"newBusinessInsightsMenu_insightsList__6dcZb","active":"newBusinessInsightsMenu_active__3N8mR"};